<template>
  <div class="text-center plus-legacy">
    <i class="fas fa-info-circle text-primary-90 mr-2"></i>
    <span v-html="text" class="mr-2"></span>
    <span
      class="text-primary-90 cursor-pointer hover:text-primary-100 font-bold"
      @click="copyText()"
    >
      {{ coupon }} <i class="fas fa-copy"></i></span>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import Utils from '@/util'
import UserApi from '@/api/user'

export default {
  name: 'PlusLegacy',
  data() {
    return {
      coupon: '',
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    text() {
      return this.$i18nPresenter.t('For customers on AhaSlides Plus only: <b>50% OFF</b> when upgrade to Pro. Use Reference Code:')
    },
  },
  async mounted() {
    if (this.currentUser.plusLegacyCoupon) {
      this.coupon = this.currentUser.plusLegacyCoupon
    } else {
      const resp = await UserApi.getPlusLegacyCoupon()
      this.coupon = resp.body.coupon
    }
  },
  methods: {
    copyText() {
      const textarea = document.createElement('textarea')
      textarea.value = this.coupon

      // Append the textarea to the document body (it needs to be part of the DOM to be selectable)
      document.body.appendChild(textarea)
      // Select the text in the textarea
      textarea.select()
      textarea.setSelectionRange(0, 99999) // For mobile devices

      // Copy the selected text to the clipboard
      document.execCommand('copy')
      // Remove the textarea from the document
      document.body.removeChild(textarea)
      Utils.showToastSuccess(`${this.$i18nPresenter.t('Copied')}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.plus-legacy {
  background-color: #F2F7FF;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 24px;
}
</style>
